import React from 'react';
import { Page } from './page';

export const Home = () => {
  return (
      <Page />
  );
}

export default Home;